import { saveAs } from 'file-saver';
import React, { ReactNode, Ref } from 'react';

import { getAsid, getPathForServer, isDeployedEnv } from '@sbu/utils.sumo';

import { ClickLink } from '../ClickLink';

export interface DownloadLinkProps
  extends React.HTMLAttributes<HTMLAnchorElement> {
  downloadPath: string;
  fileName: string;
  ref?: Ref<HTMLAnchorElement>;
  children?: ReactNode;
}

const fetchAndSaveDownload = async (path, fileName) => {
  // eslint-disable-next-line no-restricted-globals -- consider migrating to sumoFetch
  const res = await fetch(getPathForServer(path), {
    headers: isDeployedEnv
      ? {
          ApiSession: getAsid(),
        }
      : {},
  });
  const blob = await res.blob();
  saveAs(blob, fileName);
};

export const DownloadLink = React.forwardRef<
  HTMLAnchorElement,
  DownloadLinkProps
>(({ downloadPath, fileName, ...rest }, ref) => {
  return (
    <ClickLink
      onClick={() => fetchAndSaveDownload(downloadPath, fileName)}
      ref={ref}
      {...rest}
    />
  );
});
